<script setup>
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import Icon from "@/components/atoms/icon";

const emit = defineEmits(["close", "delete"]);

defineProps({
  cardType: {
    type: String,
    required: false,
    default: "Carrefour"
  }
});
</script>

<template>
  <div class="u-flex u-flex-column u-flex-align-center u-mt-xs">
    <Icon
      variant="primary"
      name="info-circle-outline"
    />
    <Titre
      tag="h1"
      size="md"
      variant="primary"
      class="u-text-center u-mt-sm u-mb-sm u-mb-xs@md u-my-lg@xs"
    >
      Êtes-vous sûr de ne pas utiliser votre Carte {{ cardType }} ?
    </Titre>
    <p class="u-text-center u-px-lg u-mb-sm u-mb-lg@xs">
      En déselectionnant le mode de paiement Carte {{ cardType }}, vous perdrez les informations déjà renseignées.
    </p>
    <div class="u-flex u-flex-justify-center u-flex-align-center u-gap-sm">
      <Button
        size="lg"
        radius="full"
        variant="primary"
        outline
        class="u-mb-sm"
        @click="emit('close')"
      >
        Utiliser
      </Button>
      <Button
        size="lg"
        radius="full"
        variant="primary"
        class="u-mb-sm"
        @click="emit('delete')"
      >
        Ne pas utiliser
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
